import wellDesignedWebsite from "../images/webtechhome/well-desinged-website.png";
import nativeVsCrossPlatform from "../images/webtechhome/nativevscrossplatform.png";
import startupEcommerce from "../images/webtechhome/Startup-e-commerce.png";

export interface SiteBlogPost {
  id: string;
  slug: string;
  title: string;
  category: string;
  date: string;
  image: string;
  excerpt: string;
  author: string;
  featured?: boolean;
}

export const siteBlogPosts: SiteBlogPost[] = [
  {
    id: "1",
    slug: "why-well-designed-website-essential-2025",
    title:
      "Why a well-designed website is essential for business success in 2025 — everything you need to know..",
    category: "web design",
    date: "March 24, 2025",
    image: wellDesignedWebsite,
    excerpt:
      "A professional website builds trust, improves conversions, and keeps your business competitive in 2025.",
    author: "WebTech Team",
    featured: true,
  },
  {
    id: "2",
    slug: "native-vs-cross-platform-apps",
    title: "Native vs cross-platform apps — which is right for your business?",
    category: "mobile apps",
    date: "April 27, 2025",
    image: nativeVsCrossPlatform,
    excerpt:
      "Compare native and cross-platform development to choose the right mobile strategy for your goals and budget.",
    author: "WebTech Team",
  },
  {
    id: "3",
    slug: "startup-ecommerce-checklist",
    title: "Startup e-commerce checklist: domain, design, payments & more..",
    category: "e-commerce",
    date: "March 17, 2025",
    image: startupEcommerce,
    excerpt:
      "Launch your online store with confidence — domain, design, payments, and essentials covered in one checklist.",
    author: "WebTech Team",
  },
];

export const featuredBlogPost = siteBlogPosts.find((post) => post.featured) ?? siteBlogPosts[0];

export const standardBlogPosts = siteBlogPosts.filter((post) => !post.featured);
